module.exports = __webpack_public_path__ + "img/logo-dark.739c84fe.png";